export const SIGN_IN = '/api/v1/auth/login'
export const REFRESH_TOKEN = '/api/v1/auth/refresh-token'
export const ACCOUNT_INFO = (userId: number) => `/api/v1/settings/user/internal/${userId}`
export const FIND_TRIP_FOR_INSTALLATION = '/api/v1/trips/installation/find-trip'
export const DEVICE_CHECK_COORDS = `/api/v1/trips/installation/check-device-coords`
export const DEVICE_IMAGE = (deviceTypeId: number) => `/api/v1/catalogs/gps-device-type/${deviceTypeId}/picture`
export const RELEASE_TRIP = (tripId: number) => `/api/v1/trips/common/${tripId}/release`
export const FIND_TRIP_FOR_CLOSING = '/api/v1/trips/close/find-trip'
export const DEVICE_UNBIND = (tripId: number) => `/api/v1/trips/close/${tripId}/device-unbind`
export const TRIP_INFO = (tripId: number) => `/api/v1/trips/close/${tripId}/info`
export const TRIP_DEVICES = (tripId: number) => `/api/v1/trips/close/${tripId}/devices`
export const TRIP_CLOSE = (tripId: number) => `/api/v1/trips/close/${tripId}`
